module.exports = __webpack_public_path__ + "static/media/phone-2.78f7c0fe.svg";